module.exports = {
	"LANGUAGE": "Dil",
	"HDR-obpa_fulltext_score": "Skor",
	"HDR-obpa_name": "isim",
	"HDR-obpa_fulltext_summary": "Özet",
	"QUERY LIMIT REACHED": "Gösterilenden daha fazla sonuç var. Lütfen arama kriterlerinizi daraltın.",
	"NO DOCUMENTS FOUND": "Belge bulunamadı.",
	"OPEN IN NEW WINDOW": "Yeni pencerede aç",
	"DOWNLOAD NATIVE": "Yerel formatta indirin",
	"CLOSE": "Kapat",
	"SEARCH TYPE": "Arama Tipi",
	"DOCUMENT TYPE": "Belge Türü",
	"SEARCH TERM": "Arama terimi",
	"SEARCH": "Arama",
	"RESET": "Sıfırla",
	"DATE": "Tarih",
	"FROM DATE": "Tarihinden İtibaren",
	"TO DATE": "Tarihine Kadar",
	"LOADING": "Yüklüyor...",
	"RETRY": "Yeniden dene",
	"ERROR": "Hata!",
	"ERROR: QUERIES": "Arama türleri listesi alınamadı.",
	"ERROR: DOCTYPES": "Belge Türleri listesi alınamıyor.",
	"ERROR: KEYWORDS": "Arama alanları listesi alınamadı.",
	"ERROR: DOCUMENTS": "İstenen arama yapılamıyor.",
	"FORM: INVALID FULLTEXT": "Alan en az {{chars}} karakterden oluşmalıdır.",
	"FORM: INVALID DATE SHORT": "Biçim: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Alan gereklidir.",
	"FORM: INVALID NUMERIC": "Alan, {{digits}} basamağa kadar bir sayı olmalıdır.",
	"FORM: INVALID DATE": "Alan formatı takip etmeli {{format}} .",
	"FORM: INVALID CURRENCY": "Alan geçerli bir para birimi değeri olmalıdır.",
	"FORM: INVALID FLOAT": "Alan bir sayı olmalıdır.",
	"FORM: INVALID LENGTH": "Alan en fazla {{chars}} karakterden oluşmalıdır.",
	"FORM: ERRORS": "Formda hatalar var.",
	"FORM: noDate": "Bir tarih aralığı belirtilmelidir.",
	"FORM: noKeyword": "En az bir alan belirtilmelidir.",
	"FORM: noDateOrKeyword": "Bir tarih aralığı VEYA en az bir alan belirtilmelidir.",
	"FORM: noDateAndKeyword": "Bir tarih aralığı VE en az bir alan belirtilmelidir."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/tr.json
// module id = 361
// module chunks = 0